import React from 'react';
import Typography from '@mui/material/Typography';
import {Images} from '../Assets/Images';
import {Box} from '@mui/material';

export default function NoDataFound({width, height}) {
  return (
    <Box className={'flex-center'}>
      <img width={width} height={height} src={Images.noData} alt="no_data"/>
      <Box className={'display-column'}>
        <Typography fontWeight={700}>Oops! Nothing to display here.</Typography>
        <Typography>It seems there's no data available right now.</Typography>
      </Box>
    </Box>
  );
}